<template>
  <DashboardOverview />
</template>

<script lang="ts">
import Vue from "vue";
import DashboardOverview from "@/components/dashboard/container/DashboardOverview.vue";

export default Vue.extend({
  components: {
    DashboardOverview,
  },
});
</script>
